import { postBooking, postDryRunBooking } from '../clients/bookings';

const BookingActions = {
  booking: {
    makeBooking(tripData) {
      return postBooking(tripData);
    },
    makeDryRunBooking(tripData) {
      return postDryRunBooking(tripData);
    },
  },
};

export default BookingActions;
